module.exports = __webpack_public_path__ + "img/naprawa-mechaniczna.6397474e.jpg";